"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _react = _interopRequireDefault(require("react"));
var _PlottableComponent = _interopRequireDefault(require("./PlottableComponent"));
var _PlottableHelpers = require("../helpers/PlottableHelpers");
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
/**
 * Component which accepts a Plottable "Plot" class instance and augments it with
 * accessors, data, and composes it with Plottable X and Y "Axis" components into a
 * Plottable "Table" component. The Table is then rendered by the PlottableComponent
 * React component wrapper.
 *
 * Can be used to render bar chart, line chart, scatter chart, etc.
 */
var PlottableXYChart = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2["default"])(PlottableXYChart, _React$Component);
  function PlottableXYChart(props) {
    var _this;
    (0, _classCallCheck2["default"])(this, PlottableXYChart);
    _this = _callSuper(this, PlottableXYChart, [props]);
    _this.state = {
      plottableComponent: null
    };
    _this.setXYPlotData = function () {};
    return _this;
  }
  (0, _createClass2["default"])(PlottableXYChart, [{
    key: "componentWillMount",
    value: function componentWillMount() {
      this.updatePlottableComponent(this.props);
    }

    // eslint-disable-next-line camelcase
  }, {
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(nextProps) {
      var _this$props = this.props,
        data = _this$props.data,
        isAxisInverted = _this$props.isAxisInverted,
        isCategorical = _this$props.isCategorical,
        isTimeSeries = _this$props.isTimeSeries,
        plot = _this$props.plot,
        series = _this$props.series,
        xAxis = _this$props.xAxis,
        focusedSeries = _this$props.focusedSeries;
      if (isAxisInverted !== nextProps.isAxisInverted || isCategorical !== nextProps.isCategorical || isTimeSeries !== nextProps.isTimeSeries || plot !== nextProps.plot || xAxis !== nextProps.xAxis) {
        this.updatePlottableComponent(nextProps);
      }
      if (data !== nextProps.data || series !== nextProps.series || focusedSeries !== nextProps.focusedSeries) {
        this.setXYPlotData({
          data: nextProps.data,
          series: nextProps.series,
          activeSeriesIndexSet: nextProps.activeSeriesIndexSet,
          focusedSeries: nextProps.focusedSeries
        });
      }
    }
  }, {
    key: "updatePlottableComponent",
    value: function updatePlottableComponent(props) {
      var isAxisInverted = props.isAxisInverted,
        isCategorical = props.isCategorical,
        isTimeSeries = props.isTimeSeries,
        disableAutorangeMode = props.disableAutorangeMode,
        xAxisDomain = props.xAxisDomain,
        yAxisDomain = props.yAxisDomain,
        buildCustomAxes = props.buildCustomAxes,
        plot = props.plot,
        xAxis = props.xAxis;
      if (!plot) {
        return;
      }
      var plottableXYChart = (0, _PlottableHelpers.buildXYChart)({
        isAxisInverted: isAxisInverted,
        isCategorical: isCategorical,
        isTimeSeries: isTimeSeries,
        disableAutorangeMode: disableAutorangeMode,
        xAxisDomain: xAxisDomain,
        yAxisDomain: yAxisDomain,
        buildCustomAxes: buildCustomAxes,
        plot: plot,
        xValue: xAxis.value
      });
      this.setXYPlotData = (0, _PlottableHelpers.setXYPlotDataFactory)(plot);
      this.setXYPlotData(props);
      this.setState({
        plottableComponent: plottableXYChart
      });
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/_react["default"].createElement(_PlottableComponent["default"], (0, _extends2["default"])({}, this.props, {
        plottableComponent: this.state.plottableComponent,
        description: this.props.description
      }));
    }
  }]);
  return PlottableXYChart;
}(_react["default"].Component);
var _default = exports["default"] = PlottableXYChart;
//# sourceMappingURL=PlottableXYChart.js.map